import type { InclusionOption } from "app/pages/sales-intelligence/types/commonMaps";

export const commonKeys = {
    clear: "common.clear",
    and: "common.and",
    thanks: "si.common.thanks",
    inclusion: (option: InclusionOption) => `si.common.inclusions.${option}` as const,

    filters: {
        range: {
            minPlaceholder: "si.common.filters.range.min.placeholder",
            maxPlaceholder: "si.common.filters.range.max.placeholder",
        },
    },
} as const;
